<template>
	<label
		@click="click"
		class="eia-label">
		<slot></slot>
		<span v-if="required"
			class="eia-label__required">
			*
		</span>
	</label>
</template>

<script>
export default {
	name: 'eia-label',
	props: {
		required: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		click( e ){
			this.$emit( 'click' , e );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-label {
	display: inline-block;
	color: $color-main;
	font-size: $text-body;
	line-height: 1.4em;
	user-select: none;
	cursor: pointer;

	&__required {
		color: $color-danger;
		display: inline-block;
	}

	&:hover {
		text-decoration-color: inherit;
	}
}
</style>
